// services/moderation/moderationApi.ts

import baseApi from "../../lib/baseApi";
import { CollaborationFormData, AccessRequestFormData } from "../../types/moderation/moderationTypes";

// Submit Collaboration Request (POST) ----------------------------------------------
export const submitCollaborationRequest = async (data: CollaborationFormData) => {
  const response = await baseApi.post("/moderation/collaborations/", data);
  return response.data;
};


// Submit Access Request -------------------------------------------------------------
export const submitAccessRequest = async (data: AccessRequestFormData) => {
  const response = await baseApi.post("/moderation/access-requests/", data);
  return response.data;
};